import * as React from 'react';
import { Box, UtilityText } from '@leagueplatform/genesis-core';

type ProgressBoxProps = {
  title: string;
  children: React.ReactNode;
};

export function ProgressBox({ title, children }: ProgressBoxProps) {
  return (
    <Box
      css={{
        backgroundColor: '$highlightBackgroundSubdued',
        borderRadius: '$medium',
        padding: '$one',
        width: '48%',
      }}
    >
      <UtilityText
        as="p"
        size="eyebrow"
        emphasis="subtle"
        css={{ marginBottom: '$quarter' }}
      >
        {title}
      </UtilityText>
      <Box as="span" css={{ display: 'inline-flex', alignItems: 'center' }}>
        {children}
      </Box>
    </Box>
  );
}
